export default {
	events: {
		'ddc.inventory.filterSearch.click': [
			{
				logic: {
					isSlider: true
				},
				payload: {
					inventory_filter_action: 'update',
					shared: [
						'[[mapping.configuration.sharedPayloads.filterSearch]]'
					]
				}
			},
			{
				logic: {
					checked: true
				},
				payload: {
					inventory_filter_action: 'add',
					shared: [
						'[[mapping.configuration.sharedPayloads.filterSearch]]'
					]
				}
			},
			{
				logic: {
					checked: false
				},
				payload: {
					inventory_filter_action: 'remove',
					shared: [
						'[[mapping.configuration.sharedPayloads.filterSearch]]'
					]
				}
			}
		],
		'ddc.form.submission': [
			{
				logic: {
					mustExist: 'trackingId',
					trackingId: 'CONTACT',
					validate: true
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'contact us',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					site_events: {
						contact_us: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					mustExist: 'trackingId',
					trackingId: 'TEST_DRIVE',
					validate: true
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.scheduleTestDrive]]'
					]
				}
			},
			{
				logic: {
					mustExist: 'trackingId',
					trackingId: 'QUICKQUOTE',
					customFormId: 'quick-quote',
					validate: true
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'qraq',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					zip_code: '[[eventData.zip]]',
					site_events: {
						qraq: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					mustExist: 'trackingTags',
					trackingTags: 'reserve',
					validate: true
				},
				payload: {
					shared: ['[[mapping.configuration.sharedPayloads.vraq]]']
				}
			},
			{
				logic: {
					mustExist: 'trackingId',
					trackingId: 'INFO_REQUEST',
					customFormId: 'inventory-lead-default',
					validate: true
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'request information',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					zip_code: '[[eventData.zip]]',
					site_events: {
						contact_us: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					mustExist: 'trackingId',
					trackingId: 'EPRICE',
					validate: true
				},
				payload: {
					shared: ['[[mapping.configuration.sharedPayloads.vraq]]']
				}
			}
		],
		'ddc.page.view': [
			{
				logic: {
					alias: 'INVENTORY_LISTING'
				},
				payload: {
					vehicle_result_list: '[[fn.vehicleYMMList()]]',
					result_count: '[[vehicleResultCount]]',
					search_type: 'search inventory',
					inventory_type: '[[mapping.pagealias.inventoryType]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.genericPageLoad]]'
					]
				},
				excluded: '_trackAnalytics'
			},
			{
				logic: {
					alias: 'INVENTORY_COMPARE'
				},
				payload: {
					category: 'shopping tools',
					action: 'compare vehicles',
					label: '',
					compare_vehicle_set: '[[fn.vehicleCompareList()]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.genericPageLoad]]'
					]
				},
				excluded: '_trackAnalytics'
			},
			{
				logic: {
					alias: '_DETAILS'
				},
				payload: {
					inventory_type: '[[mapping.pagealias.inventoryType]]',
					vehicles: '[[fn.getVehicleArray()]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.genericPageLoad]]'
					]
				},
				excluded: '_trackAnalytics'
			},
			{
				logic: {
					alias: ''
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					shared: [
						'[[mapping.configuration.sharedPayloads.genericPageLoad]]'
					]
				},
				excluded: '_trackAnalytics'
			}
		],
		'ddc.link.hproductClick': {
			payload: {
				action: 'search inventory result click',
				category: 'shopping tools',
				label: '[[eventData.text]]',
				inventory_type: '[[eventData.type]]',
				site_events: {
					search_inventory_result_click: true
				},
				site_provider: 'ddc',
				vehicles: '[[fn.getVehicleArray()]]'
			}
		},
		'ddc.link.offerClick': {
			payload: {
				category: 'engagement',
				action: 'link click',
				label: 'offer details',
				vehicles: '[[fn.getVehicleArray()]]',
				offer_type: '[[eventData.offerId]]',
				offer_name: '[[eventData.offerName]]',
				site_events: {
					offer_details: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.link.socialHeaderClick': {
			payload: {
				category: 'engagement',
				action: 'exit link',
				label: 'social interaction',
				exit_url: '[[eventData.url]]',
				social_platform: '[[eventData.service]]',
				site_events: {
					social_media_follow: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.link.socialShare': {
			payload: {
				category: 'engagement',
				action: 'exit link',
				label: 'social interaction',
				exit_url: '[[eventData.url]]',
				social_platform: '[[eventData.service]]',
				site_events: {
					social_media_follow: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.form.onPage': [
			{
				logic: {
					isModal: true,
					trackingId: 'INFO_REQUEST'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'request info',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						request_information_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					isModal: true,
					trackingId: 'TEST_DRIVE'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: '[[eventData.formTitle]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						schedule_a_test_drive_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					isModal: true,
					trackingId: 'EPRICE'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'request a quote',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						request_a_quote_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					isModal: true,
					trackingId: 'CONTACT'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: '[[eventData.formTitle]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						contact_us_click: true
					},
					site_provider: 'ddc'
				}
			}
		],
		'ddc.form.confirmation': [
			{
				logic: {
					trackingId: 'EMAIL_A_FRIEND'
				},
				payload: {
					category: 'engagement',
					action: 'share content',
					label: 'text',
					vehicles: '[[fn.getVehicleArray()]]',
					inventory_type: '[[eventData.vehicle.inventoryType]]',
					site_events: {
						text_share: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					trackingTags: 'reserve'
				},
				payload: {
					vehicles: '[[fn.getVehicleArray()]]',
					customer_lead_type: 'qraq',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type_id: '[[eventData.formEventId]]',
					site_events: {
						qraq: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					params: '_DETAILS',
					trackingId: 'EPRICE'
				},
				payload: {
					customer_lead_type_id: '[[eventData.formEventId]]',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type: 'vraq',
					inventory_type:
						'[[lookup.eventData.vehicle.inventoryType]]',
					result_count: 1,
					site_events: {
						vraq: true
					},
					site_provider: 'ddc',
					vehicles: '[[fn.getVehicleArray()]]'
				}
			},
			{
				logic: {
					params: 'INVENTORY_LISTING_DEFAULT_',
					trackingId: 'EPRICE'
				},
				payload: {
					customer_lead_type_id: '[[eventData.formEventId]]',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type: 'vraq',
					inventory_type:
						'[[lookup.eventData.vehicle.inventoryType]]',
					result_count:
						'[[eventData.prev.page.attributes.vehicleResultCount]]',
					site_events: {
						vraq: true
					},
					site_provider: 'ddc',
					vehicles: '[[fn.getVehicleArray()]]'
				}
			},
			{
				logic: {
					params: '_DETAILS',
					trackingId: 'INFO_REQUEST'
				},
				payload: {
					customer_lead_type_id: '[[eventData.formEventId]]',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type: 'vraq',
					inventory_type:
						'[[lookup.eventData.vehicle.inventoryType]]',
					result_count: 1,
					site_events: {
						vraq: true
					},
					site_provider: 'ddc',
					vehicles: '[[fn.getVehicleArray()]]'
				}
			},
			{
				logic: {
					params: 'INVENTORY_LISTING_DEFAULT_',
					trackingId: 'INFO_REQUEST'
				},
				payload: {
					customer_lead_type_id: '[[eventData.formEventId]]',
					customer_lead_level: '[[fn.getCustomerLeadLevel()]]',
					customer_lead_type: 'vraq',
					inventory_type:
						'[[lookup.eventData.vehicle.inventoryType]]',
					result_count:
						'[[eventData.prev.page.attributes.vehicleResultCount]]',
					site_events: {
						vraq: true
					},
					site_provider: 'ddc',
					vehicles: '[[fn.getVehicleArray()]]'
				}
			}
		],
		'ddc.inventory.typedSearch': {
			payload: {
				category: 'global nav',
				action: 'internal search',
				label: '[[eventData.queryFacets.search]]',
				internal_search_keyword: '[[eventData.queryFacets.search]]',
				result_count: '[[eventData.resultCount]]',
				site_events: {
					internal_search: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.link.clickToCall': {
			payload: {
				category: 'global nav',
				action: 'click to call',
				label: '[[eventData.attributes.data-phone-ref]]',
				vehicles: '[[fn.getVehicleArray()]]',
				site_events: {
					click_to_call: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.link.navClick': [
			{
				logic: {
					position: 'topNav',
					externalUrl: true,
					isChildLink: false
				},
				payload: {
					category: 'global nav',
					action: 'link click',
					label: '[[eventData.linkText]]'
				}
			},
			{
				logic: {
					position: 'topNav',
					'eventData.attributes.class': 'homeLink'
				},
				payload: {
					category: 'header',
					action: 'link click',
					label: '[[eventData.linkText]]'
				}
			},
			{
				logic: {
					position: 'topNav',
					externalUrl: true
				},
				payload: {
					category: 'engagement',
					action: 'exit link',
					label: '[[eventData.url]]'
				}
			},
			{
				logic: {
					position: 'topNav'
				},
				payload: {
					category: 'global nav',
					action: 'link click',
					label: '[[eventData.linkText]]'
				}
			}
		],
		'ddc.link.generic': [
			{
				logic: {
					widgetName: 'ws-vehicle-gallery'
				}
			},
			{
				logic: [
					({ eventData }) =>
						['ws-navigation', 'navigation-default'].includes(
							eventData?.widgetName
						) && eventData?.location === 'mainNav'
				]
			},
			{
				logic: {
					text: 'Submit'
				}
			},
			{
				logic: {
					text: 'Request More Info',
					widgetName: 'ws-vehicle-ctas'
				}
			},
			{
				logic: {
					text: 'Get Eprice',
					widgetName: 'ws-vehicle-ctas'
				}
			},
			{
				logic: {
					text: 'Schedule Test Drive',
					widgetName: 'ws-vehicle-ctas'
				}
			},
			{
				logic: {
					'eventData.attributes.class': 'ui-button-submit'
				}
			},
			{
				logic: {
					externalUrl: true,
					text: 'Call'
				}
			},
			{
				logic: {
					externalUrl: true,
					text: 'Llamar'
				}
			},
			{
				logic: {
					externalUrl: true,
					text: 'Appeler'
				}
			},
			{
				logic: {
					externalUrl: true,
					widgetId: 'contact2',
					widgetName: 'contact-info'
				}
			},
			{
				logic: {
					pageName: 'INCENTIVES_SEARCH_DETAIL'
				}
			},
			{
				logic: {
					pageName: 'SHOWROOM',
					'eventData.url': '/showroom/'
				}
			},
			{
				logic: {
					'eventData.attributes.class': 'payment-summary-calculate',
					pageName: '_DETAILS'
				}
			},
			{
				logic: {
					widgetName: 'ws-detailed-incentives'
				}
			},
			{
				logic: {
					trackingLabel: 'lead form print link'
				},
				payload: {
					category: 'engagement',
					action: 'print content',
					label: '[[eventData.text]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						print_content: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: ({ eventData }) =>
					(
						eventData?.url || eventData?.attributes?.['data-src']
					)?.includes('/windowsticker/genesis'),
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: '[[eventData.text]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						view_window_sticker: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					url: 'reserve'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: '[[eventData.text]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						reserve_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					url: 'carfax.com/cfm/ccc_displayhistoryrpt.cfm'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'view carfax',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						view_carfax: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					externalUrl: true,
					url: 'google.com/maps'
				},
				payload: {
					category: 'dealer info',
					action: 'exit link',
					label: '[[eventData.url]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						get_directions: true,
						property_referral: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					externalUrl: true
				},
				payload: {
					category: 'engagement',
					action: 'exit link',
					label: '[[eventData.url]]',
					site_events: {
						property_referral: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					url: '/dealership/directions.htm'
				},
				payload: {
					category: 'dealer info',
					action: 'link click',
					label: 'get directions',
					site_events: {
						get_directions: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					location: 'footer'
				},
				payload: {
					category: 'footer',
					action: 'link click',
					label: '[[eventData.text]]'
				}
			},
			{
				logic: {
					location: 'header'
				},
				payload: {
					category: 'header',
					action: 'link click',
					label: '[[eventData.text]]'
				}
			},
			{
				payload: {
					category: 'engagement',
					action: 'link click',
					label: '[[eventData.text]]'
				}
			}
		],
		'ddc.video.play': {
			payload: {
				video_name: '[[eventData.videoSource]]',
				site_events: {
					video_start: true
				},
				site_provider: 'ddc'
			}
		},
		'ddc.video.milestone': [
			{
				logic: {
					'eventData.videoMilestone': 'complete'
				},
				payload: {
					video_name: '[[eventData.videoSource]]',
					video_duration: '[[eventData.videoDuration]]',
					video_time_viewed: '[[eventData.videoDuration]]',
					site_events: {
						video_complete: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					mustNotInclude: {
						'eventData.videoMilestone': '95'
					}
				},
				payload: {
					video_name: '[[eventData.videoSource]]',
					video_duration: '[[eventData.videoDuration]]',
					video_time_viewed: '[[fn.calculateVideoViewTime()]]',
					site_events: {
						'video_[[eventData.videoMilestone]]_percent': true
					},
					site_provider: 'ddc'
				}
			}
		],
		userEvent: [
			{
				logic: {
					eventLocation: 'Finance Application Thank You Page'
				},
				payload: {
					shared: [
						'[[mapping.configuration.sharedPayloads.applyForCredit]]'
					]
				}
			}
		],
		widgetUserEvent: [
			{
				logic: {
					widgetName: 'xtime-scheduler',
					result: 'Appointment Conversion'
				},
				payload: {
					site_events: {
						schedule_service: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					mustExist: '[[eventData.searchTerm]]',
					widgetName: 'ws-site-text-search'
				},
				payload: {
					category: 'global nav',
					action: 'internal search',
					label: 'result',
					internal_search_keyword: '[[eventData.searchTerm]]',
					site_events: {
						internal_search: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					action: 'clicked',
					result: 'Opens payment calculator button'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'payment calculator',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						payment_calculator_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					action: 'clicked',
					result: 'Available specials expanded'
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: 'view offers',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						view_offers_click: true
					},
					site_provider: 'ddc'
				}
			},
			{
				logic: {
					isWindowStickerLink: true
				},
				payload: {
					category: 'shopping tools',
					action: 'cta click',
					label: '[[eventData.text]]',
					vehicles: '[[fn.getVehicleArray()]]',
					site_events: {
						view_window_sticker: true
					},
					site_provider: 'ddc'
				}
			}
		]
	}
};
